import createAxiosInstance from './Axios';

export const callValidateRutGoldSilver = async (data, baseURL) => {
  const axiosInstance = createAxiosInstance(baseURL);
  return axiosInstance({
    url: `/form/validation/rut`,
    method: 'post',
    data: data,
  });
};
